import React from 'react'

export default function homePage() {
  return (
    <h1>AI Generated Radiology Reports.</h1>
  )
}
